export default __webpack_public_path__ + "static/media/gas-graphic.3e2f1513.svg";